import { Component } from 'react'
import { _T } from '../../i18n'
import { getDatadogRum } from '../../framework/externals'
import { SomethingWentWrongSVG } from '@panwds/react-ui'
import './ErrorBoundary.scss'
import type { ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
  context?: string
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  }

  static getDerivedStateFromError(_: Error) {
    // Update error state
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    getDatadogRum()?.addError(error, {
      type: 'client_error',
      error_boundry_context: this.props.context,
    })
    // log the error
    const context = this.props.context ? `React error boundry "${this.props.context}":` : ''
    console.log(context, error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='panwds-tw3 fullpage-message no-nav text-center'>
          <div className='message-icon'>
            <SomethingWentWrongSVG width='175' height='163' />
          </div>
          <h2>
            {_T('Something went wrong')}
          </h2>
          <div>
            <p className='mx-auto'>
              {_T('Please reload the page. If the problem persists, contact customer support.')}
            </p>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
